import { useState } from "react";
import { Radio, Users, Network, TrendingUp, Megaphone, BarChart3, UploadCloud, Settings as Cog, LayoutGrid } from "lucide-react";
import { Link } from "react-router-dom";
import { C } from "./ui";
import { Wordmark } from "../consumer/ui";
import OpsConsole from "./OpsConsole";
import IncidentDetail from "./IncidentDetail";
import Customers from "./Customers";
import CustomerDetail from "./CustomerDetail";
import Partners from "./Partners";
import Leads from "./Leads";
import Communications from "./Communications";
import Reports from "./Reports";
import ImportMigration from "./ImportMigration";
import AdminSettings from "./AdminSettings";

const NAV = [
  { id: "ops", label: "Ops Console", icon: Radio },
  { id: "customers", label: "Customers", icon: Users },
  { id: "partners", label: "Partners", icon: Network, commercial: true },
  { id: "leads", label: "Leads", icon: TrendingUp },
  { id: "comms", label: "Communications", icon: Megaphone },
  { id: "reports", label: "Reports", icon: BarChart3 },
  { id: "imports", label: "Import", icon: UploadCloud },
  { id: "settings", label: "Settings", icon: Cog },
];

const FILTERS = [["all", "All"], ["consumer", "ResQ1 Consumer"], ["commercial", "ResQconnect Commercial"]];

export default function AdminWireframe() {
  const [screen, setScreen] = useState("ops");
  const [product, setProduct] = useState("all");
  const nav = (s) => setScreen(s);

  const screens = {
    ops: <OpsConsole nav={nav} product={product} />,
    incident: <IncidentDetail nav={nav} />,
    customers: <Customers nav={nav} product={product} />,
    customer: <CustomerDetail nav={nav} />,
    partners: <Partners />,
    leads: <Leads />,
    comms: <Communications />,
    reports: <Reports />,
    imports: <ImportMigration />,
    settings: <AdminSettings />,
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", fontFamily: "'Inter', system-ui, sans-serif", background: C.body }} data-testid="admin-wireframe">
      {/* Sidebar */}
      <aside style={{ width: 232, background: C.navy, color: "#fff", flexShrink: 0, padding: "22px 14px", display: "flex", flexDirection: "column", position: "sticky", top: 0, height: "100vh" }}>
        <div style={{ padding: "0 8px 20px" }}><Wordmark light /></div>
        <nav style={{ display: "flex", flexDirection: "column", gap: 3 }}>
          {NAV.map((n) => {
            const on = screen === n.id || (n.id === "ops" && screen === "incident") || (n.id === "customers" && screen === "customer");
            const dim = n.commercial && product === "consumer";
            const Icon = n.icon;
            return (
              <button key={n.id} onClick={() => nav(n.id)} data-testid={`admin-nav-${n.id}`}
                style={{ display: "flex", alignItems: "center", gap: 11, padding: "10px 12px", borderRadius: 8, border: 0, background: on ? C.red : "transparent", color: on ? "#fff" : dim ? "rgba(255,255,255,0.35)" : "rgba(255,255,255,0.78)", fontSize: 13.5, fontWeight: on ? 600 : 500, cursor: "pointer", textAlign: "left" }}>
                <Icon size={17} /> {n.label}
              </button>
            );
          })}
        </nav>
        <Link to="/prototype" data-testid="admin-to-hub" style={{ marginTop: "auto", display: "flex", alignItems: "center", gap: 8, padding: "10px 12px", color: "rgba(255,255,255,0.6)", fontSize: 12.5, textDecoration: "none" }}>
          <LayoutGrid size={15} /> Prototype hub
        </Link>
      </aside>

      {/* Main */}
      <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>
        <header style={{ display: "flex", alignItems: "center", gap: 14, padding: "14px 28px", borderBottom: "1px solid rgba(26,30,36,0.08)", background: "rgba(247,245,240,0.9)", backdropFilter: "blur(10px)", position: "sticky", top: 0, zIndex: 10 }}>
          <span style={{ fontSize: 11, fontFamily: "'JetBrains Mono', monospace", color: C.slate, letterSpacing: "0.06em" }}>WIREFRAME · MOCK DATA</span>
          <div style={{ marginLeft: "auto", display: "flex", gap: 5, background: "#fff", padding: 4, borderRadius: 999, border: "1px solid rgba(26,30,36,0.1)" }} data-testid="admin-product-filter">
            {FILTERS.map(([id, label]) => (
              <button key={id} onClick={() => setProduct(id)} data-testid={`filter-${id}`}
                style={{ padding: "6px 13px", borderRadius: 999, border: 0, background: product === id ? C.ink : "transparent", color: product === id ? "#fff" : C.slate, fontSize: 12.5, fontWeight: 600, cursor: "pointer" }}>
                {label}
              </button>
            ))}
          </div>
        </header>
        <main style={{ padding: "28px", flex: 1, overflowY: "auto" }}>{screens[screen]}</main>
      </div>
    </div>
  );
}
